window.merchantos.form_validation = {
  /**
   * Validate obj value is not empty.
   * Changes obj class accordingly.
   *
   * @param {type} obj Field object
   */
  isEmptyAddBorder(obj) {
    // this class was added to item notes for inline editting
    // validation
    if (!obj.hasClass('item_note')) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
      if (this.isEmpty(obj.val())) {
        obj.addClass('error-highlight');
      } else {
        obj.removeClass('error-highlight');
      }
    }
  },

  isEmpty(note) {
    let rtn = false;

    // Matches on any non-whitespace character.
    if (!/\S/.test(note)) {
      rtn = true;
    }
    return rtn;
  },
};

// Error handler for Empty Misc and Labor notes. Item notes are the exception.
$(document).on('keyup', '.error_no_empty_notes', function onNotesKeyup() {
  window.merchantos.form_validation.isEmptyAddBorder($(this));
});
